import { useMemo } from 'react';

import { fetchMetadataRevision } from '@api/editorialLayout/revisions';
import env from '@config/runtimeConfig';
import useLoad from '@hooks/useLoad';
import { SourceId } from '@modules/simulations/types';

import { huaweiHosts, withHuaweiHosts } from '../huaweiHosts';
import { RevisionId } from '../types';

import useRawDataRevision from './useRawDataRevision';

const useParseRevision = ({ hash, playbackOptionId }: RevisionId, enabled?: boolean) => {
  const { sourceId } = useRawDataRevision();

  const queryResult = useLoad(
    () => fetchMetadataRevision(playbackOptionId, hash),
    ['raw-data-revision', playbackOptionId, hash],
    { enabled }
  );

  const { data } = queryResult;

  const { parsedMetadata, parsingError } = useMemo(() => {
    if (!data?.metadata) return {};

    try {
      switch (data.type) {
        case 'json':
          return {
            parsedMetadata:
              sourceId === SourceId.HUAWEI_EPG
                ? withHuaweiHosts(JSON.parse(data.metadata), huaweiHosts[env])
                : JSON.parse(data.metadata),
          };
        case 'xml':
          return { parsedMetadata: data.metadata };
        default:
          console.warn('Unsupported format');
          return {};
      }
    } catch (err) {
      console.error(err);
      return { parsingError: err as object };
    }
  }, [data, sourceId]);

  return { parsingError, parsedMetadata, language: data?.type, queryResult };
};

export default useParseRevision;
